import { Component } from "@angular/core";
import { environment } from "src/environments/environment";
import { SingleTabGuardService } from "./guards/single-tab-guard.service";
import { LoginService } from "@dert-services";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  title = "client-dert-pos";

  constructor(singleTabGuardService: SingleTabGuardService, loginService: LoginService) {
    console.log(`Environment: ${environment.production ? "Production" : "Development"}`);
    console.log(`ApiURL: ${environment.apiAddress}`);

    singleTabGuardService.setSingleTab();

    loginService.tryLoadUser();
  }
}
